import { createI18n } from 'vue-i18n';
import store from "../store";

import zhLocale from 'view-ui-plus/dist/locale/zh-CN'
import enLocale from 'view-ui-plus/dist/locale/en-US'
import zhmessage from '@/assets/lang/CN/message_zh_cn_new'
import enmessage from '@/assets/lang/EN/message_en_us_new'

import langSource from "../assets/lang/langSource";

/*---------使用语言包-----------*/
const mergeZH = Object.assign(zhLocale, zhmessage)
const mergeZH2 = {'zh-CN': mergeZH};
const mergeEN = Object.assign(enLocale, enmessage)
const mergeEN2 = {'en-US': mergeEN};
const localResult = Object.assign(mergeZH2, mergeEN2)

let ll=localStorage.getItem('langJSON');
let lang;
if(ll){
  lang= JSON.parse(ll);
}

let langType;
if (lang && lang.type && langSource.getLangByType(lang.type)) {
  store.dispatch('setLang', {icon: lang.icon, type: lang.type})
  langType = lang.type;
} else {
  store.dispatch('setLang', {icon: langSource.getEnglishLangIcon(), type: langSource.getEnglishLangType()})
  langType = langSource.getEnglishLangType()
}

export default createI18n({
  globalInjection: true, //如果设置true, $t() 函数将注册到全局
  silentTranslationWarn: false,
  legacy: false,
  missingWarn: false,
  silentFallbackWarn: true,
  fallbackWarn: false,
  locale: langType, // 采用全局参数配置初始化语言 项目中有`zh-cn`、`en`两种
  fallbackLocale: langType,
  messages: localResult,
});
